import React, { useState } from "react";
import { Footer, Header } from "../../Components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axiosClient from "../../AxiosClient";
import { remove } from "../../Services/LocalStorageService";
import { logout } from "../../Redux/SliceAuthUser";

import { Spinner } from "flowbite-react"

const VerifeyEmail = () => {
  document.title = "Verify Email - Famra Cure";

  const UserData = useSelector((state) => state.authUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const ResendVerificationEmail = () => {
    setIsLoading(true);
    setMessage(null);
    axiosClient
      .get(`/email/resend/${UserData.user.id}`)
      .then(() => {
        setMessage({ type: "success", text: "Verification email sent. Please check your inbox and your spam/junk folder." });
      })
      .catch((err) => {
        console.log(err);
        setMessage({ type: "error", text: err?.response?.data?.message || "Could not send the email. Please try again." });
      })
      .finally(() => setIsLoading(false));
  };

  const HandleLogout = () => {
    axiosClient
      .post("/user/logout")
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(logout());
        remove("TOKEN_USER");
        navigate("/user-login");
      });
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#f3f6fb]">
      <Header />
      <main className="flex-1 flex justify-center items-center px-4 py-12">
        <div className="bg-white w-full max-w-lg p-6 md:p-8 rounded-xl shadow-lg text-left">
          <div className="w-14 h-14 rounded-full bg-blue-50 flex items-center justify-center mb-4">
            <i className="fa-regular fa-envelope-circle-check text-2xl text-[#3e7cc4]"></i>
          </div>
          <h2 className="mb-2 text-2xl font-bold text-zinc-800">
            Verify your email
          </h2>
          <p className="mb-6 text-base text-zinc-600 leading-relaxed">
            Thank you for registering with Famra Cure. We have sent a verification link to{" "}
            <span className="font-medium text-[#3e7cc4] break-all">
              {UserData?.user?.email}
            </span>
            . Please open the email and click the link to activate your account.
            If you can't find it, check your spam or junk folder.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={ResendVerificationEmail}
              disabled={isLoading}
              className={`${isLoading ? 'opacity-50' : 'opacity-100'} flex items-center justify-center rounded-lg bg-[#0d63f3] px-5 py-2.5 font-medium text-white hover:bg-[#0a4bb4] transition-colors`}
            >
              {isLoading ? <Spinner size="sm" /> : "Resend verification email"}
            </button>
            <button
              onClick={HandleLogout}
              disabled={isLoading}
              className="rounded-lg border border-gray-300 bg-white px-5 py-2.5 font-medium text-gray-800 hover:bg-gray-100 transition-colors"
            >
              Logout
            </button>
          </div>
          {message && (
            <p className={`mt-5 px-4 py-2 rounded-lg text-sm ${message.type === "success" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-600"}`}>
              {message.text}
            </p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VerifeyEmail;
